import { createContext } from 'react';

// can add other diff features that vary between pr, branch, and commit page
// ex: comments, comment nav, etc
export type DiffFeatures = {
  multiCommentReview: boolean;
  hasMarkFilesAsViewed: boolean;
  hasAnnotations: boolean;
  hasComments: boolean;
  // The PR page can still show preview merges if the PR is old enough so we
  // need to allow for this possibility.
  previewMergeOption: boolean;
  extraStickyHeaderHeight: boolean;
  hasCommentNav: boolean;
  onSideBySideClicked?: () => void;
  onShowCommentsClicked?: () => void;
};

const defaultFeatures: DiffFeatures = {
  multiCommentReview: false,
  hasMarkFilesAsViewed: false,
  hasAnnotations: false,
  hasComments: false,
  previewMergeOption: false,
  extraStickyHeaderHeight: false,
  hasCommentNav: false,
};

export const DiffFeaturesContext = createContext(defaultFeatures);
